import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react'
import ContactForm from "../ContactForm/index";
import OfficeDetails from "../OfficeDetails/index";

export default class ContactUs extends Component {

    render() {

        return (
            <div>
                <Grid stackable>
                    <Grid.Column className='grid-padding'>
                        <Container>
                            <OfficeDetails />
                        </Container>
                        <Container>
                            <ContactForm />
                        </Container>
                    </Grid.Column>
                </Grid>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactUs/index.js